// ABOUTME: Two-button Yes/No toggle matching Figma design — individual bordered buttons, no pill wrapper.
// ABOUTME: Used in PumpSettingsForm default answers section for boolean field selection.
import React from 'react'

export interface CountryConfigsSwitchControlOption {
  value: string
  label: string
}

export interface CountryConfigsSwitchControlProps {
  value: string
  options: [CountryConfigsSwitchControlOption, CountryConfigsSwitchControlOption]
  onChange: (value: string) => void
  disabled?: boolean
  'data-cy'?: string
  'aria-label'?: string
}

export const CountryConfigsSwitchControl: React.FC<CountryConfigsSwitchControlProps> = ({
  value,
  options,
  onChange,
  disabled,
  'data-cy': dataCy,
  'aria-label': ariaLabel,
}) => {
  return (
    <div role="group" aria-label={ariaLabel} className="flex gap-1 items-center w-[160px]" data-cy={dataCy}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          disabled={disabled}
          aria-pressed={option.value === value}
          onClick={() => {
            if (!disabled && option.value !== value) {
              onChange(option.value)
            }
          }}
          className={
            option.value === value
              ? 'flex-1 flex items-center justify-center px-3 py-2 rounded-md text-foreground_inverted bg-button_background_toggled'
              : 'flex-1 flex items-center justify-center px-3 py-2 rounded-md text-foreground bg-button_background outline outline-1 outline-offset-[-1px] outline-border'
          }
        >
          <span className="text-base font-medium leading-6 whitespace-nowrap">{option.label}</span>
        </button>
      ))}
    </div>
  )
}
